import { useMemo } from 'react'

export function useDeviceDetect() {
  return useMemo(() => {
    const ua = navigator.userAgent
    const isIOS = /iPhone|iPad|iPod/.test(ua)
    const isAndroid = /Android/.test(ua)
    return { isIOS, isAndroid, isMobile: isIOS || isAndroid }
  }, [])
}
